import { render } from "./Announcement.vue?vue&type=template&id=4aa1c528&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Announcement.vue?vue&type=style&index=1&id=4aa1c528&scoped=true&lang=css"

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa1c528"]])

export default __exports__